import { Injectable } from '@angular/core';
import { NgbDatepicker, NgbDatepickerKeyboardService } from '@ng-bootstrap/ng-bootstrap';

const Key = {
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  PageUp: 'PageUp',
  PageDown: 'PageDown',
  End: 'End',
  Home: 'Home'
};

@Injectable()
export class CustomKeyboardService extends NgbDatepickerKeyboardService {
  processKey(event: KeyboardEvent, dp: NgbDatepicker) {
    switch (event.code) {
      case Key.ArrowUp:
      case Key.ArrowDown:
      case Key.ArrowLeft:
      case Key.ArrowRight:
      case Key.PageUp:
      case Key.PageDown:
      case Key.End:
      case Key.Home:
        event.preventDefault();
        event.stopPropagation();
        break;
      default:
        super.processKey(event, dp);
        return;
    }
  }
}
